class ArticleEventCard extends HTMLElement {
  connectedCallback() {
    this.startUTCDate = this.getAttribute('data-utc-start-timestamp');
    this.endUTCDate = this.getAttribute('data-utc-end-timestamp');
    this.targetElement = this.querySelector('[data-event-time-wrapper]');
    this.articleTitle = this.getAttribute('data-article-title');
    if (!this.startUTCDate || !this.targetElement) return;
    this.addStartAndEndTimesToElement();
  }

  addStartAndEndTimesToElement() {
    const startDate = new Date(this.startUTCDate);
    const startTimeMarkup = this.dateToTimeMarkup(startDate);

    let endTimeMarkup;
    if (this.endUTCDate) {
      const endDate = new Date(this.endUTCDate);
      endTimeMarkup = this.dateToTimeMarkup(endDate);
    }

    this.createAndAddTargetElementMarkup(startTimeMarkup, endTimeMarkup);
  }

  dateToTimeMarkup(date) {
    const timeString = date.toLocaleTimeString('en-GB', {
      timeZone: 'Europe/Amsterdam',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });

    return `<time datetime="${date.toISOString()}">${timeString}</time>`;
  }

  createAndAddTargetElementMarkup(startTimeMarkup, endTimeMarkup) {
    this.targetElement.innerHTML = startTimeMarkup;
    if (endTimeMarkup) {
      this.targetElement.innerHTML += ` - ${endTimeMarkup}`;
    }
  }
}

customElements.define('article-event-card', ArticleEventCard);
